/**
 * Lógica de Negócios para o Modal de Exercícios
 * 
 * Responsabilidade:
 * - Interagir com a API de serviços (criar/atualizar exercícios).
 * - Processar dados antes do envio.
 * - Separar a lógica de API do componente React.
 */

import exercicies from "../../services/exercicies";
import { Exercise } from "../../types";

export const saveExercise = async (
  form: Partial<Exercise>,
  professional_id: number | undefined
) => {
  if (form.id !== undefined && form.id !== null && form.id !== 0) {
    return await exercicies.update(String(form.id), form);
  } else {
    const body = {
      ...form,
      professional_id:
        form.professional_id ||
        (professional_id ? Number(professional_id) : 0),
      name: form.name || "",
    } as Exercise;

    return await exercicies.create(body);
  }
};
